export const DEFAULT_SUPPORT_EMAIL = "support@codeer.ai"

export const SUPPORT_EMAIL =
  import.meta.env.VITE_SUPPORT_EMAIL?.trim() || DEFAULT_SUPPORT_EMAIL

export const getSupportMailto = (subject?: string) => {
  const params = subject ? `?subject=${encodeURIComponent(subject)}` : ""
  return `mailto:${SUPPORT_EMAIL}${params}`
}
